// extracted by mini-css-extract-plugin
module.exports = {"dayOfWeekName_withPrices":"dayOfWeekName_withPrices-sreYC"};